module.exports = __webpack_public_path__ + "static/media/floatingPhones.b6b662bd.png";